import { action } from 'typesafe-actions'
import { BackDropTypes } from './constants'

export const setShow = (show) => action(BackDropTypes.SET_SHOW, { show })
